import React, { useEffect, useState } from "react"
import Form from 'react-bootstrap/Form';
import ReactPaginate from 'react-paginate';

const ListsPagination = (props) => {
    //if pagination is happening from backend, we need to call the API on change of page or size of the page, in the case the below props are mandatory for this Component
    // fetchData -> call back function hwhich call the api and update the list
    //dataCount -> length of the total data not the current displaying data length

    // if pagination is from front end, below props are mandatory
    //setCurrentItems, lists
    
    const {setCurrentItems, lists, resetPagination, fetchData, dataCount} = props
    const [itemsPerPage, setItemsPerPage] = useState(10)
    const [itemOffset, setItemOffset] = useState(0);
    const [selectedPage, setSelectedPage] = useState(0)
    const [pageCount, setPageCount] = useState(0);

    useEffect(() => {
        const endOffset = itemOffset + itemsPerPage;
        if (fetchData) {
            fetchData(selectedPage +1, itemsPerPage)
            setPageCount(Math.ceil(dataCount / itemsPerPage))
            return;
        }
        setCurrentItems(lists.slice(itemOffset, endOffset));
        setPageCount(Math.ceil(lists.length / itemsPerPage));
    }, [itemOffset, itemsPerPage, lists, dataCount]);

    useEffect(() => {
        setSelectedPage(0)
        setItemOffset(0)
    },[resetPagination])

    const itemPerChangeHandler = (count) => {
        setItemsPerPage(count)
        setItemOffset(0)
        setSelectedPage(0)
    }

    const handlePageClick = (event) => {
        const newOffset = event.selected * itemsPerPage % (fetchData ? dataCount :lists.length);
        setItemOffset(newOffset);
        setSelectedPage(event.selected)
    };
  return (
    <div className="d-flex align-items-center justify-content-end">
        <div className="d-flex">
            Select Limit :
            <Form className="ms-3">
                {['radio'].map((type) => (
                    <div key={`inline-${type}`} className="mb-3">
                        <Form.Check
                            inline
                            label="10"
                            name="group1"
                            type={type}
                            //checked={itemsPerPage == 10}
                            //onChange={(e) => e.target.value == "on" && itemPerChangeHandler(10)}
                            id={`inline-${type}-1`}
                        >
                            <Form.Check.Input type="radio" style={{ cursor: 'pointer' }} onChange={(e) => e.target.value == "on" && itemPerChangeHandler(10)} checked={itemsPerPage == 10} />
                            <Form.Check.Label >10</Form.Check.Label>
                        </Form.Check>
                        <Form.Check
                            inline
                            //label="25"
                            name="group1"
                            type={type}
                            //checked={itemsPerPage == 25}
                            //onChange={(e) => e.target.value == "on" && itemPerChangeHandler(25)}
                            id={`inline-${type}-2`}
                        >
                            <Form.Check.Input type="radio" style={{ cursor: 'pointer' }} onChange={(e) => e.target.value == "on" && itemPerChangeHandler(25)} checked={itemsPerPage == 25} />
                            <Form.Check.Label >25</Form.Check.Label>
                        </Form.Check>
                        <Form.Check
                            inline
                            label="50"
                            name="group1"
                            type={type}
                            //checked={itemsPerPage == 50}
                            //onChange={(e) => e.target.value == "on" && itemPerChangeHandler(50)}
                            id={`inline-${type}-3`}
                        >
                            <Form.Check.Input type="radio" style={{ cursor: 'pointer' }} onChange={(e) => e.target.value == "on" && itemPerChangeHandler(50)} checked={itemsPerPage == 50} />
                            <Form.Check.Label >50</Form.Check.Label>
                        </Form.Check>
                        <Form.Check
                                inline
                                label="100"
                                name="group1"
                                type={type}
                                id={`inline-${type}-4`}
                            >
                                <Form.Check.Input type="radio" style={{ cursor: 'pointer' }} onChange={(e) => e.target.value === "on" && itemPerChangeHandler(100)} checked={itemsPerPage === 100} />
                                <Form.Check.Label>100</Form.Check.Label>
                            </Form.Check>
                            <Form.Check
                                inline
                                label="150"
                                name="group1"
                                type={type}
                                id={`inline-${type}-5`}
                            >
                                <Form.Check.Input type="radio" style={{ cursor: 'pointer' }} onChange={(e) => e.target.value === "on" && itemPerChangeHandler(150)} checked={itemsPerPage === 150} />
                                <Form.Check.Label>150</Form.Check.Label>
                            </Form.Check>

                    </div>
                ))}
            </Form>
        </div>
        <ReactPaginate
            nextLabel=">>"
            onPageChange={(e) => handlePageClick(e)}
            pageRangeDisplayed={3}
            marginPagesDisplayed={2}
            pageCount={pageCount}
            forcePage={selectedPage}
            previousLabel="<<"
            pageClassName="page-item"
            pageLinkClassName="page-link"
            previousClassName="page-item"
            previousLinkClassName="page-link"
            nextClassName="page-item"
            nextLinkClassName="page-link"
            breakLabel="..."
            breakClassName="page-item"
            breakLinkClassName="page-link"
            containerClassName="pagination"
            activeClassName="active"
            renderOnZeroPageCount={null}
        />
    </div> 
  )
};

export default ListsPagination;